// src/components/visualizations/DataTable.vue

<template>
  <v-card elevation="12" outlined class="overflow">
    <v-card-title style="color: #4062bb">
      <v-btn icon @click="downloadData">
        <v-icon>mdi-download</v-icon>
      </v-btn>

      <v-spacer></v-spacer>
      <h4 class="gradient-text">Plots Detail</h4>
      <v-spacer></v-spacer>

      <v-text-field
        class="shrink"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="tableData"
      :items-per-page="5"
      :search="search"
      :loading="loading"
      multi-sort
      dense
      class="elevation-1"
    >
      <template v-slot:item.SoldStatus="{ item }">
        <v-chip
          :color="item.SoldStatus === 'Sold' ? 'success' : 'warning'"
          small
          dark
        >
          {{ item.SoldStatus }}
        </v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import JsonExcel from 'vue-json-excel';

export default {
  name: 'DataTable',

  components: {
    downloadExcel: JsonExcel
  },

  data() {
    return {
      search: '',
      loading: false,
      headers: [
        { text: 'Plot ID', value: 'plot_id' },
        // { text: 'Dimensions', value: 'Dimensions' },
        { text: 'Zone', value: 'Zone' },
        { text: 'Type', value: 'Type' },
        { text: 'Status', value: 'SoldStatus' }
      ]
    };
  },

  computed: {
    ...mapGetters('geojson', ['filteredFeatures']),

    tableData() {
      return this.filteredFeatures.map(feature => ({
        plot_id: feature.properties.plot_id || '-',
        Dimensions: feature.properties.Dimensions || '-',
        Zone: feature.properties.Zone || '-',
        J_Owner: feature.properties.J_Owner || '-',
        Type: feature.properties.Type || '-',
        SoldStatus: feature.properties.SoldStatus || '-'
      }));
    }
  },

  methods: {
    downloadData() {
      const csvContent = "data:text/csv;charset=utf-8," 
        + this.headers.map(h => h.text).join(",") + "\n"
        + this.tableData.map(row => 
            Object.values(row).join(",")
          ).join("\n");

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `feature-data-${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>